module.exports = __webpack_public_path__ + "static/media/org.320238cc.svg";